import apiServices from 'config/apiServiceApiGateway'
import { Post as PostService, Put as PutService } from 'config/apiServiceConfig'

const { Get } = apiServices

export type GetAllSegmentsResponseType = {
  name: string
  id: number
  total_user: number
}[]

export type PostPutPayloadBannerType = {
  banner_name: string
  banner_image: string | null
  banner_date_start: number
  banner_date_end: number
  banner_hubs: {
    location_id: number
    name: string
    position: number
    status: number
  }[]
  banner_position?: number
  targeting_type?: number
  list_user_id: number[]
  category_id?: number | null
  banner_url?: string | null
  total_position?: number
  category_active?: boolean
  fallback_url?: string
  banner_text_color?: string
  banner_image_old?: {
    image_url_small: string
    image_url_medium: string
    image_url_large: string
    version_type_id: number
  }
  banner_image_new?: {
    image_url_small: string
    image_url_medium: string
    image_url_large: string
    version_type_id: number
  }
  banner_segmentations?: {
    type_id: number
    segment_type_id: number
  }[]
  is_recurring_schedule: boolean
}

export type PostPutBannerResponseDataType = {
  banner_id: number
  banner_name: string
  banner_position: number
  banner_date_start: number
  banner_date_end: number
  banner_active: boolean
}

export const getAllSegments = () =>
  Get<GetAllSegmentsResponseType>({ url: `/segmentation/internal/v1/segment` })

export const postBanner = (data: Partial<PostPutPayloadBannerType>) =>
  PostService<PostPutBannerResponseDataType>({
    url: '/api/banner',
    data,
  })

export const putBanner = (bannerId: number, data: Partial<PostPutPayloadBannerType>) =>
  PutService<PostPutBannerResponseDataType>({
    url: '/api/banner/:bannerId',
    data,
    urlParams: { bannerId },
  })

export type GetBannerKongRequestType = {
  params: {
    name?: string
    page_size: number
    page_index: number
  }
}

export type GetBannerKongResponseType = {
  data: {
    targeting_type: number
    list_user_id: number[]
    list_current_targeted_users: { user_id: number; user_name: string; banner_id: number }[]
    banner_segmentations: unknown[]
    targeting_type_name: string
    banner_id: number
    banner_name: string
    category_name: string
    banner_position: number
    banner_image: string
    banner_url: string
    banner_hubs: {
      location_id: number
      name: string
      position: number
      status: number
    }[]
    banner_date_start: number
    banner_date_end: number
    banner_active: boolean
  }[]
}
export const getBannerKong = ({ params }: GetBannerKongRequestType) =>
  Get<GetBannerKongResponseType, true>({ url: `/browse/internal/v1/banner`, params })
